<div class="tw-flex tw-flex-col tw-gap-4">
  <app-input
    [label]="'fileName' | i18n"
    [boldLabel]="false"
    [value]="fileName"
    (outputValue)="onFileNameChanged($event)"
  ></app-input>

  <app-cabinet-datepicker
    [fromDate]="fromDate"
    [toDate]="toDate"
    (dateRangeChanged)="onDateRangeChanged($event)"
  ></app-cabinet-datepicker>

  <app-gloss-button
    [options]="saveButtonOptions"
    [fontClass]="'tw-text-white'"
    class="tw-w-full"
  ></app-gloss-button>
</div>
